var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOverviewActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.02862C8.71321 5.21493 7.47849 5.68741 6.38877 6.41777C4.94984 7.38218 3.82833 8.75294 3.16606 10.3567C2.50379 11.9605 2.33051 13.7252 2.66813 15.4277C3.00576 17.1303 3.83911 18.6942 5.06282 19.9216C6.28653 21.1491 7.84563 21.985 9.54297 22.3237C11.2403 22.6623 12.9996 22.4885 14.5985 21.8242C16.1973 21.1599 17.5639 20.035 18.5254 18.5916C19.2535 17.4985 19.7245 16.26 19.9103 14.9693H12.5C11.1193 14.9693 10 13.8466 10 12.4616V5.02862ZM9.84738 2.51898C11.3843 2.32526 12.5 3.60253 12.5 4.93861V12.4616H20C21.332 12.4616 22.6054 13.5808 22.4122 15.1224C22.1951 16.8557 21.5787 18.5216 20.604 19.9848C19.3679 21.8405 17.6109 23.2869 15.5552 24.141C13.4995 24.9951 11.2375 25.2186 9.05524 24.7831C6.87295 24.3477 4.8684 23.273 3.29505 21.6948C1.72171 20.1166 0.650254 18.1059 0.216171 15.917C-0.217913 13.728 0.00487454 11.459 0.856361 9.39706C1.70785 7.33508 3.14979 5.57268 4.99984 4.33272C6.45858 3.35503 8.11937 2.73678 9.84738 2.51898Z",
    fill: "url(#paint0_linear_0_83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 2.43094C13.75 1.10328 14.8657 -0.199352 16.4237 0.0254475C17.2473 0.14427 18.0547 0.365996 18.8268 0.686807C20.0401 1.1909 21.1425 1.92975 22.0711 2.86119C22.9997 3.79262 23.7363 4.8984 24.2388 6.11538C24.5586 6.88988 24.7797 7.69977 24.8981 8.52586C25.1222 10.0887 23.8236 11.2078 22.5 11.2078L15.125 11.2078C14.3656 11.2078 13.75 10.5903 13.75 9.82857V2.43094ZM22.3951 8.70012C22.3014 8.14388 22.1453 7.59866 21.9291 7.07502C21.5522 6.16229 20.9997 5.33295 20.3033 4.63438C19.6069 3.9358 18.7801 3.38166 17.8701 3.00359C17.3481 2.78669 16.8045 2.63018 16.25 2.53616V8.70012L22.3951 8.70012Z",
    fill: "url(#paint1_linear_0_83)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_83",
    x1: 0.377292,
    y1: 2.49941,
    x2: 22.9126,
    y2: 2.99178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_83",
    x1: 23.9117,
    y1: 11.2078,
    x2: 13.8832,
    y2: 10.1163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677095,
    stopColor: "#F3D25C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverviewActive);
export default __webpack_public_path__ + "static/media/icon_overview_active.d92dbb9ce760dba5437a4ce52b574df5.svg";
export { ForwardRef as ReactComponent };